// ENTITY fr.gestionpial.pial.dto.EmploiDuTempsLookupsDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { Ecole } from './Ecole';
import { Aesh } from './Aesh';
import { Classe } from './Classe';
import { AffectationAesh } from './AffectationAesh';
import { Notification } from './Notification';

export class EmploiDuTempsLookupsDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.EmploiDuTempsLookupsDTO';

  aeshs: Map<number, Aesh> | null = null;
  affectations: Map<number, AffectationAesh> | null = null;
  notifications: Map<number, Notification> | null = null;
  classes: Map<number, Classe> | null = null;
  ecoles: Map<number, Ecole> | null = null;

  constructor(init?:Partial<EmploiDuTempsLookupsDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.EmploiDuTempsLookupsDTO'] = EmploiDuTempsLookupsDTO;

fields['fr.gestionpial.pial.dto.EmploiDuTempsLookupsDTO']  = {
    aeshs: 'java.util.Map<java.lang.Integer,fr.gestionpial.pial.entities.Aesh>',
    affectations: 'java.util.Map<java.lang.Integer,fr.gestionpial.pial.entities.AffectationAesh>',
    notifications: 'java.util.Map<java.lang.Integer,fr.gestionpial.pial.entities.Notification>',
    classes: 'java.util.Map<java.lang.Integer,fr.gestionpial.pial.entities.Classe>',
    ecoles: 'java.util.Map<java.lang.Integer,fr.gestionpial.pial.entities.Ecole>'
};
